import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-prose py-12">
      <h1 className="text-xl font-semibold">{t('notFound.title')}</h1>
      <p className="mt-2 text-sm text-[var(--color-muted-foreground)]">
        {t('notFound.description')}
      </p>
      <Link className="mt-4 inline-block text-sm underline" to="/">
        {t('notFound.back')}
      </Link>
    </div>
  );
}
